import { type ReactNode } from "react";

import { Box, ListItemButton } from "@mui/material";

import { onPrimarySurfaceColor } from "@/src/theme/helpers";

interface HeaderMenuItemProps {
  id: string;
  onClick: () => void;
  label: ReactNode;
  isActive?: boolean;
  attentionCount?: number;
}

const HeaderMenuItem = (props: HeaderMenuItemProps) => {
  const { id, onClick, label, isActive, attentionCount } = props;

  return (
    <ListItemButton
      id={id}
      onClick={onClick}
      sx={(muiTheme) => ({
        textDecoration: "none",
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          left: 0,
          bottom: 0,
          width: "100%",
          borderBottom: isActive
            ? `2px solid ${onPrimarySurfaceColor(muiTheme)}`
            : "none"
        }
      })}
    >
      {label}
      {(attentionCount ?? 0) > 0 && (
        <Box
          sx={(muiTheme) => ({
            ml: 0.5,
            color: onPrimarySurfaceColor(muiTheme),
            fontWeight: muiTheme.typography.fontWeightMedium
          })}
        >
          ({attentionCount})
        </Box>
      )}
    </ListItemButton>
  );
};

export default HeaderMenuItem;
